import * as React from 'react';
import { useReducer } from 'react';

interface ExtractQuestionsState {
  includeExplanation: boolean;
}

type ExtractQuestionsAction =
  | {
      type: 'setIncludeExplanation';
      payload: { newIncludeExplanation: boolean };
    }
  | { type: 'reset' };

function initialState() {
  return { includeExplanation: true };
}

function reducer(
  state: ExtractQuestionsState,
  action: ExtractQuestionsAction
): ExtractQuestionsState {
  switch (action.type) {
    case 'setIncludeExplanation': {
      const { newIncludeExplanation } = action.payload;
      return { ...state, includeExplanation: newIncludeExplanation };
    }
    case 'reset': {
      return initialState();
    }
    default: {
      const _exhaustiveCheck: never = action;
      if (__DEV__) {
        console.error('Unhandled action type:', _exhaustiveCheck);
      }
      return state;
    }
  }
}

export type DispatchExtractQuestionsAction =
  React.Dispatch<ExtractQuestionsAction>;

export function useExtractQuestionsReducer(): {
  state: ExtractQuestionsState;
  dispatch: DispatchExtractQuestionsAction;
} {
  const [state, dispatch] = useReducer(reducer, initialState());
  return { state, dispatch };
}
